import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { Field, reduxForm, Form } from 'redux-form';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import { Prompt } from 'react-router-dom';

import renderTextField from '../helpers/RenderTextFiledWithDiv';
import validationHelper from '../helpers/ValidationHelper';
import normalizePhone from '../helpers/NormalizePhone';
import RenderDialog from '../helpers/RenderDialog';

import updatePerson from '../actions/updatePerson';
import getPerson from '../actions/getPerson';


const styles = theme => ({
  cardTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    fontSize: '20px'
  },
  marginStyle: {
    margin: 8
  },
  textField: {
    width: 350,
  }
});

const errorPaperStyle = {
  display: 'inline-block',
  width: '75%',
  background: '#F2F2F2',
  fontSize: '13px',
  border: '2px solid #FA1414',
  boxSizing: 'border-box',
  boxShadow: '0px 15px 10px rgba(0, 0, 0, 0.25)',
  borderRadius: '10px',
  marginTop: '20px',
  height: '20px'
};

const okPaperStyle = {
  display: 'inline-block',
  width: '75%',
  background: '#F2F2F2',
  fontSize: '13px',
  border: '2px solid #14FA14',
  boxSizing: 'border-box',
  boxShadow: '0px 15px 10px rgba(0, 0, 0, 0.25)',
  borderRadius: '10px',
  marginTop: '20px',
  height: '20px'
};

const validate = (values) => {
  const errors = validationHelper.validateRequired(['firstName', 'lastName', 'email'], values);
  if (values.email && !validationHelper.validateEmail(values.email)) {
    errors.email = 'Invalid email address';
  }
  if (values.phoneNumber && !validationHelper.validatePhone(values.phoneNumber)) {
    errors.phoneNumber = 'Invalid phone number';
  }
  const lengthValidation = [
    { field: 'firstName', label: 'First Name', value: values.firstName, min: 1, max: 20 },
    { field: 'lastName', label: 'Last Name', value: values.lastName, min: 1, max: 30 },
    { field: 'suffix', label: 'Suffix', value: values.suffix, min: 1, max: 20 }
  ];
  validationHelper.validateLength(errors, lengthValidation);
  return errors;
};

class UserForm extends Component {
  state = {
    savedOk: false,
    attemptedToSave: false,
    error: null,
    openDialog: false,
    message: ""
  };

  handleSave = (event) => {
    const locations = this.props.person.locations.map(location => ({
      locationId: location.locationId, roleId: location.role.roleId
    }));

    const userInfo = {
      personId: this.props.person.personId,
      firstName: event.firstName || '',
      lastName: event.lastName || '',
      suffix: event.suffix || '',
      email: event.email,
      cognitoId: this.props.person.cognitoId,
      isActive: true,
      phoneNumber: event.phoneNumber || '',
      personLocations: locations
    };

    this.props.actions.updateUser(userInfo, this.props.config, this);
  }

  handleClose = () => {
    this.setState({ openDialog: false });
  }

  render() {
    const { classes, handleSubmit } = this.props;

    let errorPaper = <div />;
    if (this.state.error) {
      errorPaper = <Paper style={errorPaperStyle}>{this.state.error.message}</Paper>;
    }

    let okPaper = <div />;
    if (this.props.updateUser && this.props.updateUser.fetched) {
      okPaper = <Paper style={okPaperStyle}>Settings saved</Paper>;
    }

    return (
      <Form key="UserForm" onSubmit={handleSubmit(this.handleSave)}>
        {errorPaper}
        {okPaper}
        <Prompt
          when={!this.state.savedOk && this.props.dirty}
          message="Any changes will be lost if you leave this screen. Would you like to continue?"
        />
        <Field disabled name="email" component={renderTextField} label="Email Address" className={classes.textField} divClassName={classes.marginStyle} />
        <Field name="firstName" component={renderTextField} label="First Name" className={classes.textField} divClassName={classes.marginStyle} />
        <Field name="lastName" component={renderTextField} label="Last Name" className={classes.textField} divClassName={classes.marginStyle} />
        <Field name="suffix" component={renderTextField} label="Suffix" className={classes.textField} divClassName={classes.marginStyle} />
        <Field name="phoneNumber" normalize={normalizePhone} component={renderTextField} label="Phone Number" className={classes.textField} divClassName={classes.marginStyle} />
        <Button variant="raised" color="primary" type="submit" className={classes.marginStyle}>Save</Button>
        <RenderDialog
          open={this.state.openDialog}
          confirmButton
          message={this.state.message}
          onClose={this.handleClose}
        />
      </Form>
    );
  }
}

UserForm.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapDispatchToProps = dispatch => ({
  actions: {
    currentUser: (config) => {
      dispatch(null(config));
    },
    updateUser: (userInfo, config, self) => {
      self.setState({ savedOk: false, attemptedToSave: true });
      dispatch(updatePerson(userInfo, config)).then((o) => {
        self.setState({ savedOk: true, attemptedToSave: true, openDialog: true, message: "Record Saved" });
        dispatch(getPerson(null, userInfo.cognitoId, config));
      });
    }
  }
});

const ReduxUserForm = withStyles(styles, { withTheme: true })(reduxForm({ form: 'UserForm', enableReinitialize: true, validate })(UserForm));
const ConnectedForm = connect(
  state => ({
    initialValues: state.person.person,
    person: state.person.person,
    updateUser: state.updateUser,
    config: state.config.config,
  }),
  mapDispatchToProps
)(ReduxUserForm);

export default ConnectedForm;


// WEBPACK FOOTER //
// ./src/containers/UserForm.js